import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import * as M from './styled'
import { ProjectType } from 'types'
const Modal: React.FC<{
  active: boolean
  project: ProjectType | undefined
  handleClose: () => void
}> = ({ active, handleClose, project }) => {
  const location = useLocation()
  useEffect(() => {
    document.getElementsByTagName('html')[0].style.overflow = ''
    document.body.style.overflowY = ''
  }, [location.pathname])
  if (!project) return null
  return (
    <M.Container $active={active}>
      <M.Content></M.Content>

      <M.Close onClick={() => handleClose()}>⨯</M.Close>
    </M.Container>
  )
}
export default Modal
